import React from 'react';
import {graphql} from 'gatsby';
import Img from 'gatsby-image';
import styles from './styles.module.scss';
import Layout from '@components/Layout';
import SEO from '@components/SEO';
import StructuredData from '@components/StructuredData';
import { SITE_URL, stripHtml, ORG_REF } from '@helpers/schema';
import Hero from '@components/Hero';
import {Col, Grid, Row} from '@components/Grid';
import moment from "moment";

const BlogPost = ({
	                  data: {
		                  page: {
			                  frontmatter: {
				                  path,
				                  blogTitle,
				                  seoTitle,
				                  seoDescription,
				                  blogHeroImage,
				                  blogAuthor,
				                  blogPublished,
				                  blogBody,
				                  blogUrl,
			                  },
		                  },
	                  },
                  }) => {


	const embedUrl = blogUrl ? blogUrl?.replace('watch?v=', 'embed/') : '';
	const heroImageSrc = blogHeroImage?.childImageSharp?.fluid?.src;
	const heroImageUrl = heroImageSrc
		? heroImageSrc.startsWith('http') ? heroImageSrc : `${SITE_URL}${heroImageSrc}`
		: undefined;

	return (
		<Layout>
			<SEO title={seoTitle} description={seoDescription}/>
			<StructuredData
				schema={[
					{
						'@context': 'https://schema.org',
						'@type': 'BlogPosting',
						'@id': `${SITE_URL}${path}#blogposting`,
						headline: blogTitle,
						url: `${SITE_URL}${path}`,
						...(heroImageUrl && { image: heroImageUrl }),
						...(blogPublished && { datePublished: new Date(blogPublished).toISOString() }),
						...(blogAuthor && { author: { '@type': 'Person', name: blogAuthor } }),
						publisher: ORG_REF,
						...(seoDescription && { description: seoDescription }),
						...(blogBody && { articleBody: stripHtml(blogBody).slice(0, 5000) }),
						mainEntityOfPage: { '@type': 'WebPage', '@id': `${SITE_URL}${path}#webpage` },
					},
				]}
			/>
			<Hero image={blogHeroImage}>
				<h1>{blogTitle}</h1>

				<div className={styles.blogHeroMeta}>
					<p>By {blogAuthor}</p> · <p>{moment(new Date(blogPublished)).format("Do MMMM Y")}</p>
				</div>

			</Hero>

			<Grid>
				<Row>
					{!!embedUrl &&
						<Col xs={12}>
							<iframe style={{aspectRatio: '16 / 9', marginBottom: '2rem'}} width='100%'
							        src={embedUrl}
							        title='YouTube video player' frameBorder='0'
							        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
							        allowFullScreen></iframe>
						</Col>
					}

					<Col xs={12}>
						<div className={styles.blogContentWrapper}>
							{!!blogBody && <div dangerouslySetInnerHTML={{__html: blogBody}}/>}
						</div>
					</Col>
				</Row>
			</Grid>
		</Layout>
	);
};

export default BlogPost;

export const query = () => graphql`
    query BlogPostQuery($path: String!) {
        page: markdownRemark(frontmatter: { path: { eq: $path } }) {
            frontmatter {
                path
                seoTitle: blog_post_seo_title
                seoDescription: blog_post_seo_description
                blogBody: blog_post_body
                blogTitle: blog_post_title
                blogUrl: blog_post_url
                blogHeroImage: blog_post_hero_image {
                    childImageSharp {
                        fluid(maxWidth: 800, maxHeight: 600) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                blogTags: blog_post_tags {
                    blog_tag
                }
                blogTagIds: blog_post_tag_ids {
                    blog_tag_id
                }
                blogAuthor: blog_post_author
                blogPublished: blog_post_published
            }
        }
    }
`;
